import React, {Component} from 'react'
import { Table } from 'antd'
import "./style.less"
import { getAgentInfo } from "@/api/agent"
import { timestamp2DateStr } from "@/utils/format"

class AgentInfo extends Component {
    constructor(pros) {
        super(pros);
        this.state = {
            columns: [
                {
                    title: "name",
                    dataIndex: "name",
                    width: "200",
                },
                {
                    title: "value",
                    dataIndex: "value",
                    width: "200",
                }
            ],
            data: [
            ],
        }
    }

    agentLevelMap = {
        "INVALID": "未开通",
        "GOLD": "黄金服务商",
        "PLATINUM": "铂金服务商",
        "DIAMOND": "钻石服务商",
    };

    initData = () => {
        getAgentInfo()
            .then(data => {
                    this.setState(
                        {
                            loading: false,
                            baseData: [
                                {
                                    "name": "服务商账号",
                                    "value": data.userId
                                },
                                {
                                    "name": "联系人",
                                    "value": data.contact,
                                },
                                {
                                    "name": "联系电话",
                                    "value": data.phoneNo,
                                },
                                {
                                    "name": "加盟日期",
                                    "value": timestamp2DateStr(data.joinTime)
                                },
                            ],
                            kzData: [
                                {
                                    "name": "当前等级",
                                    "value": this.agentLevelMap[data.level]
                                },
                                {
                                    "name": "账户余额",
                                    "value": data.balance / 100 + "元",
                                },
                                {
                                    "name": "累计充值",
                                    "value": data.chargeSum / 100 + "元",
                                },
                            ],
                            kmData: [
                                {
                                    "name": "当前等级",
                                    "value": this.agentLevelMap[data.kmLevel]
                                },
                                {
                                    "name": "账户余额",
                                    "value": data.kmBalance / 100 + "元",
                                },
                                {
                                    "name": "累计充值",
                                    "value": data.kmChargeSum / 100 + "元",
                                },
                            ],
                        }
                    );
                }
            );
    };

    componentDidMount() {
        this.initData();
    }

    render() {
        return (
            <React.Fragment>
                <div className="agent-info">
                    <div className="info">账户信息</div>
                    <Table bordered={true} pagination={false} showHeader={false} loading={this.state.loading}
                           columns={this.state.columns} dataSource={this.state.baseData} />
                    <div className="info">快站代理信息</div>
                    <Table bordered={true} pagination={false} showHeader={false} loading={this.state.loading}
                           columns={this.state.columns} dataSource={this.state.kzData} />
                    <div className="info">快码代理信息</div>
                    <Table bordered={true} pagination={false} showHeader={false} loading={this.state.loading}
                           columns={this.state.columns} dataSource={this.state.kmData} />
                </div>
            </React.Fragment>
        );
    }
}

export default AgentInfo;